import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
const HeroSidebar = ({ header, subheader }) => {
  return (
              <div className="lg:w-1/2">
            <h1 className="
              text-[2.5rem] lg:text-[3rem] leading-[3.125rem] lg:leading-[3.875rem]
              text-white font-bold mb-6 break-words
            ">
              {parse(header)}
            </h1>
            <p className="font-semibold text-white text-lg mb-7">
              {parse(subheader)}
            </p>
          </div>
  );
};

HeroSidebar.propTypes = {
  header: PropTypes.string,
  subheader: PropTypes.string
};

export default HeroSidebar;